module.exports = __webpack_public_path__ + "img/ico201.7b6a62b8.svg";